module.exports = __webpack_public_path__ + "static/img/Upload.763ac784.png";